module.exports = __webpack_public_path__ + "static/img/order.7a93e14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order.png
// module id = x5oV
// module chunks = 17